import { useNotetakerEntitled } from 'features/meeting_intelligence'
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'
import { useTrack } from 'hooks/analytics_events/useTrack'

const trackV2Hits = {}

const checkHit = (key) => {
  if (trackV2Hits[key]) { return true }

  trackV2Hits[key] = true

  return false
}

// This is called after useMeetingIntelligenceFeatureFlag because it sends the event to Segment.
// The event name and payload remain `meeting_intelligence` to keep analytics dashboards stable
// even though the gate has migrated from the Experimenter flag to the Notetaker entitlement.
export const trackMiV2 = (track) => {
  const flagKey = 'meeting_intelligence'

  if (!checkHit(flagKey)) {
    track({
      name: TRACKING_EVENT_NAMES.FEATURE_FLAG_ENCOUNTERED,
      properties: {
        flag_key: 'meeting_intelligence',
        rule: 'targeted_delivery',
        source: 'frontend',
        variation_key: 'on'
      }
    })
  }
}

export const useMeetingIntelligenceFeatureFlag = () => {
  const { isEntitled: isNotetakerEntitled } = useNotetakerEntitled()
  const track = useTrack()

  if (isNotetakerEntitled) {
    trackMiV2(track)
  }

  return isNotetakerEntitled
}
